module.exports = "<app-qavisit [title]=\"title\"></app-qavisit>"